<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="keepAlive" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!keepAlive" :key="key"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.path;
    },
    keepAlive() {
      return this.$route.meta.keepAlive;
    },
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #eff2f5;
}

#app {
  height: 100vh;
  width: 100%;
}
</style>
